export const NOW_PLAYING_SLOT_NAME_AND_ID = 'nowPlaying_side';
